window.chartBasisrenteKlassik = {
	data: {
		// Liqui
		bruttowerte: [],
		vorsorgebeitraege: [],
		leistungen: [],
		beraterkostens: [],
		versichererkostens: [],
		// Steuer
		zves: [],
		altersvorsorgeaufwendungen: [],
		sozialversicherungen: [],
		// Buschutz
		bu_leistungen: [],
		burente_beitraege: [],
		beitragsbefreiung_beitraege: [],
		// Todesfallschutz
		todesfallschutz_versicherungssummen: [],
		risiko_versicherungssummen: [],
		risiko_beitraege: [],
		todesfallschutz_beitraege: [],
		// Sonstiges
		bewertungsdatum: 0,
		leistungsdatum: 0,
		startdatum: 0,
		enddatum: 0,
	},

	showLoading() {
		if (this.chart) this.chart.showLoading()
	},

	hideLoading() {
		if (this.chart) this.chart.hideLoading()
	},

	init() {
		this.chart = new Highcharts.stockChart("chart_basisrente_klassik", {
			chart: {
				chartType: "liqui", // ["liqui", "steuer"]
				events: {
					selection: function (event) {
						return zoomIn(chartBasisrenteKlassik, event)
					},
				},
			},

			yAxis: [
				{},
				{
					opposite: true,
				},
			],

			xAxis: {
				ordinal: false,
				min: this.data.startdatum,
				max: this.data.enddatum,
				anzeigeformat: "jahr",
				plotLines: [
					{
						id: "bewertungsplotline",
						color: "#2F3435",
						width: 2,
						dashStyle: "longdashdot",
						zIndex: 10,
						bewertungsdatum: this.data.bewertungsdatum,
						value: this.data.bewertungsdatum - 60 * 60 * 24 * (365 - 30.41) * 1000, // Das Chart öffnet immer in der Jahresansicht
						label: {
							text: `Aktuelle Bewertung<br>zum ${moment(new Date(this.data.bewertungsdatum)).format("MM/YYYY")}`,
							rotation: 0,
							y: 15,
							x: 10,
							textAlign: "left",
							style: {
								color: chartFontColorGrau,
								fontSize: "14px",
							},
						},
					},
				],
				events: {
					afterSetExtremes: function (event) {
						const chart = event.target.chart,
							min = event.min,
							max = event.max

						updateDataGrouping(chart, min, max)
						updateBewertungPlotline(chart)
					},
				},
			},

			legend: {
				enabled: true,
			},

			plotOptions: {
				area: {
					stacking: "normal",
				},
			},

			series: this.seriesLiqui(),
		})

		// Wenn der Chart Zeitraum kleiner ist als die Monatsgrenze das DataGrouping deaktivieren
		updateDataGrouping(this.chart, this.data.startdatum, this.data.enddatum)
	},

	update() {
		if (!this.chart) return

		this.chart.showLoading()

		const seriesArrays = [this.seriesLiqui(), this.seriesSteuer(), this.seriesBuschutz(), this.seriesTodesfallschutz()]
		const alleSeries = [].concat(...seriesArrays)

		alleSeries.forEach((serie) => {
			const s = this.chart.get(serie.id)
			if (s) {
				s.update({ zones: serie.zones }, false)
				this.chart.redraw()
				s.setData(serie.data, false)
			}
		})

		// xAchse: Min und Max aktualisieren
		this.updateXAxisMinMax()

		// Bewertungsline aktualisieren
		this.updateBewertungLinie()

		this.chart.redraw({ duration: chartAnimationDuration })
		this.chart.hideLoading()
	},

	updateXAxisMinMax() {
		const seriesMaxValues = this.chart.series.map((serie) => (Array.isArray(serie.xData) ? serie.xData.slice(-1)[0] : undefined)),
			xAxisMaxValue = Math.max(this.data.enddatum, ...seriesMaxValues.filter((element) => element !== undefined))
		this.chart.xAxis[0].update({ min: this.data.startdatum, max: xAxisMaxValue })
	},

	updateBewertungLinie() {
		const plotLineOptions = this.chart.xAxis[0].options.plotLines[0]
		plotLineOptions.bewertungsdatum = this.data.bewertungsdatum
		plotLineOptions.value = this.data.bewertungsdatum
		plotLineOptions.label.text = `Aktuelle Bewertung<br>zum ${moment(new Date(this.data.bewertungsdatum)).format("MM / YYYY")}`

		if (this.chart.options.plotOptions.series.dataGrouping.enabled) {
			plotLineOptions.value = plotLineOptions.bewertungsdatum - 60 * 60 * 24 * (365 - 30.41) * 1000
		}

		this.chart.xAxis[0].options.plotLines[0] = Object.assign({}, this.chart.xAxis[0].options.plotLines[0], plotLineOptions)
	},

	updateSeriesData(seriesData, chartType) {
		// Alle Series entfernen
		while (this.chart.series.length > 0) {
			this.chart.series[0].remove(false)
		}

		// Series hinzufügen
		seriesData.forEach((serie) => {
			this.chart.addSeries(serie, false)
		})

		// XAchse Max Data prüfen und ggf. aktualisieren
		this.updateXAxisMinMax()

		// ChartType setzuen damit in der Detailansicht unterschieden werden kann ob liqui oder steuer
		this.chart.options.chart.chartType = chartType
		this.chart.redraw({ duration: chartAnimationDuration })
	},

	seriesLiqui() {
		return [
			{
				name: "Vertragswert",
				id: "vertragswert",
				legendName: "Vertragswert",
				yAxis: 0,
				type: "area",
				color: farbeNettovermoegen,
				zIndex: 0,
				zoneAxis: "x",
				zones: [
					{
						value: this.data.leistungsdatum,
						color: farbeNettovermoegen,
					},
					{
						color: farbeDeckungsstock,
					},
				],
				data: this.data.bruttowerte,
			},
			{
				name: "Sparbeitrag",
				id: "beitrag",
				legendName: "Beitrag",
				yAxis: 1,
				type: "column",
				color: farbeBeitrag1,
				zIndex: 1,
				data: this.data.vorsorgebeitraege,
			},
			{
				name: "Leistung",
				id: "leistung",
				legendName: "Leistung",
				yAxis: 1,
				type: "column",
				color: farbeLeistung,
				zIndex: 1,
				data: this.data.leistungen,
			},
			{
				name: "Beraterkosten",
				id: "beraterkosten",
				legendName: "Kosten",
				yAxis: 1,
				type: "column",
				color: farbeKosten,
				zIndex: 1,
				data: this.data.beraterkostens,
			},
			{
				name: "Versichererkosten",
				id: "versichererkosten",
				yAxis: 1,
				type: "column",
				color: farbeKosten,
				zIndex: 1,
				linkedTo: "beraterkosten",
				data: this.data.versichererkostens,
			},
		]
	},

	seriesSteuer() {
		return [
			{
				name: "steuerpflichtiges Einkommen",
				id: "zve",
				legendName: "steuerpflichtiges Einkommen",
				type: "column",
				color: farbeZuVersteuerndesEinkommen,
				data: this.data.zves,
			},
			{
				name: "sozialpflichtiges Einkommen",
				id: "sve",
				legendName: "sozialpflichtiges Einkommen",
				type: "column",
				color: farbeSozialpflichtigesEinkommen,
				stack: "sve",
				data: this.data.sozialversicherungen,
			},
			{
				name: "Altersvorsorgeaufwendung",
				id: "altersvorsorgeaufwendung",
				legendName: "Altersvorsorgeaufwendung",
				type: "column",
				color: farbeSteuererstattung,
				zIndex: 1,
				data: this.data.altersvorsorgeaufwendungen,
			},
		]
	},

	seriesBuschutz() {
		return [
			{
				name: "Gesamte Versicherungsleistung",
				id: "bu_leistung",
				legendName: "Gesamte Versicherungsleistung",
				yAxis: 0,
				type: "area",
				color: farbeLeistung,
				opacity: "0.5",
				zIndex: 0,
				dataGrouping: {
					approximation: "sum",
				},
				data: this.data.bu_leistungen,
			},
			{
				name: "Beitrag zur BU-Rente",
				id: "burente",
				legendName: "Beitrag zur BU-Rente",
				yAxis: 0,
				type: "column",
				color: farbeBeitrag1,
				zIndex: 0,
				data: this.data.burente_beitraege,
			},
			{
				name: "Beitrag zur Beitragsbefreiung",
				id: "beitragsbefreiung",
				legendName: "Beitrag zur Beitragsbefreiung",
				yAxis: 0,
				type: "column",
				color: farbeBeitrag2,
				zIndex: 0,
				data: this.data.beitragsbefreiung_beitraege,
			},
		]
	},

	seriesTodesfallschutz() {
		return [
			{
				name: "Todesfallschutz",
				id: "versicherungssumme_todesfallschutz",
				legendName: "Versicherungsleistung",
				yAxis: 0,
				type: "area",
				color: farbeLeistung,
				opacity: "0.5",
				zIndex: 0,
				data: this.data.todesfallschutz_versicherungssummen,
			},
			{
				name: "Risikolebensversicherung",
				id: "versicherungssumme_risiko",
				legendName: "Gesamte Versicherungsleistung",
				yAxis: 0,
				type: "area",
				color: farbeLeistung,
				opacity: "0.5",
				zIndex: 0,
				linkedTo: "versicherungssumme_todesfallschutz",
				data: this.data.risiko_versicherungssummen,
			},
			{
				name: "Beitrag zur Risikolebensversicherung",
				id: "beitrag_risiko",
				legendName: "Beiträge",
				yAxis: 1,
				type: "column",
				color: farbeBeitrag1,
				zIndex: 1,
				data: this.data.risiko_beitraege,
			},
			{
				name: "Beitrag zum Todesfallschutz",
				id: "beitrag_todesfallschutz",
				legendName: "Beitrag zum Todesfallschutz",
				yAxis: 1,
				type: "column",
				color: farbeBeitrag1,
				linkedTo: "beitrag_risiko",
				zIndex: 1,
				data: this.data.todesfallschutz_beitraege,
			},
		]
	},
}
